
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import PlatformMarkerGroundLava from "../../editor/platform-markers/cave/PlatformMarkerGroundLava";
import PlatformMarkerStack3 from "../../editor/platform-markers/cave/PlatformMarkerStack3";
import PlatformMarkerStack2 from "../../editor/platform-markers/cave/PlatformMarkerStack2";
import PlatformMarkerStack1 from "../../editor/platform-markers/cave/PlatformMarkerStack1";
import PlatformMarkerPlatMini from "../../editor/platform-markers/cave/PlatformMarkerPlatMini";
import TrapMarkerTorch from "../../editor/trap-markers/cave/TrapMarkerTorch";
import MegaGemMarker from "../../editor/entity-markers/MegaGemMarker";
import PlatformMarkerRock from "../../editor/platform-markers/cave/PlatformMarkerRock";
import SmashableMarkerRocks from "../../editor/entity-markers/SmashableMarkerRocks";
import SimpleBreakableBlocker from "../../../components/platformer/SimpleBreakableBlocker";
import PlatformMarkerPlat from "../../editor/platform-markers/cave/PlatformMarkerPlat";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class CaveChunkHard1 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? -381.58257912127925, y ?? 178.22467347422582);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, 233, 368);
    this.add(editor_bounds_left);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 7474, 368);
    this.add(editor_bounds_right);

    // gemMarker_5
    const gemMarker_5 = new SmallGemMarker(scene, 457, 229);
    this.add(gemMarker_5);

    // platformMarkerGroundLava_1
    const platformMarkerGroundLava_1 = new PlatformMarkerGroundLava(scene, 444, 303);
    this.add(platformMarkerGroundLava_1);

    // platformMarkerStack3
    const platformMarkerStack3 = new PlatformMarkerStack3(scene, 1664, 228);
    this.add(platformMarkerStack3);

    // platformMarkerStack_2
    const platformMarkerStack_2 = new PlatformMarkerStack2(scene, 2364, 260);
    this.add(platformMarkerStack_2);

    // platformMarkerStack1
    const platformMarkerStack1 = new PlatformMarkerStack1(scene, 2012, 285);
    this.add(platformMarkerStack1);

    // platformMarkerStack_3
    const platformMarkerStack_3 = new PlatformMarkerStack3(scene, 3151, 248);
    this.add(platformMarkerStack_3);

    // platformMarkerStack_4
    const platformMarkerStack_4 = new PlatformMarkerStack1(scene, 2090, 285);
    this.add(platformMarkerStack_4);

    // platformMarkerStack_5
    const platformMarkerStack_5 = new PlatformMarkerStack3(scene, 1740, 229);
    this.add(platformMarkerStack_5);

    // platformMarkerPlatMini_6
    const platformMarkerPlatMini_6 = new PlatformMarkerPlatMini(scene, 2798, 214);
    this.add(platformMarkerPlatMini_6);

    // platformMarkerStack_9
    const platformMarkerStack_9 = new PlatformMarkerStack3(scene, 4606, 249);
    this.add(platformMarkerStack_9);

    // platformMarkerStack_14
    const platformMarkerStack_14 = new PlatformMarkerStack3(scene, 4682, 250);
    this.add(platformMarkerStack_14);

    // platformMarkerGroundLava_2
    const platformMarkerGroundLava_2 = new PlatformMarkerGroundLava(scene, 6982, 312);
    this.add(platformMarkerGroundLava_2);

    // trapMarkerTorch_7
    const trapMarkerTorch_7 = new TrapMarkerTorch(scene, 2371, 140);
    this.add(trapMarkerTorch_7);

    // platformMarkerStack_19
    const platformMarkerStack_19 = new PlatformMarkerStack1(scene, 2974, 311);
    this.add(platformMarkerStack_19);

    // trapMarkerTorch_1
    const trapMarkerTorch_1 = new TrapMarkerTorch(scene, 2975, 217);
    this.add(trapMarkerTorch_1);

    // platformMarkerStack_20
    const platformMarkerStack_20 = new PlatformMarkerStack3(scene, 3222, 248);
    this.add(platformMarkerStack_20);

    // trapMarkerTorch_2
    const trapMarkerTorch_2 = new TrapMarkerTorch(scene, 3484, 107);
    this.add(trapMarkerTorch_2);

    // platformMarkerStack_15
    const platformMarkerStack_15 = new PlatformMarkerStack3(scene, 3484, 253);
    this.add(platformMarkerStack_15);

    // platformMarkerStack_16
    const platformMarkerStack_16 = new PlatformMarkerStack1(scene, 3752, 311);
    this.add(platformMarkerStack_16);

    // platformMarkerStack_23
    const platformMarkerStack_23 = new PlatformMarkerStack3(scene, 4464, 251);
    this.add(platformMarkerStack_23);

    // platformMarkerStack_24
    const platformMarkerStack_24 = new PlatformMarkerStack3(scene, 4388, 250);
    this.add(platformMarkerStack_24);

    // trapMarkerTorch_3
    const trapMarkerTorch_3 = new TrapMarkerTorch(scene, 4388, 103);
    this.add(trapMarkerTorch_3);

    // trapMarkerTorch_4
    const trapMarkerTorch_4 = new TrapMarkerTorch(scene, 4461, 107);
    this.add(trapMarkerTorch_4);

    // platformMarkerStack_25
    const platformMarkerStack_25 = new PlatformMarkerStack1(scene, 3817, 312);
    this.add(platformMarkerStack_25);

    // platformMarkerGroundLava_3
    const platformMarkerGroundLava_3 = new PlatformMarkerGroundLava(scene, 5129, 303);
    this.add(platformMarkerGroundLava_3);

    // platformMarkerPlatMini_7
    const platformMarkerPlatMini_7 = new PlatformMarkerPlatMini(scene, 5579, 217);
    this.add(platformMarkerPlatMini_7);

    // platformMarkerPlatMini_9
    const platformMarkerPlatMini_9 = new PlatformMarkerPlatMini(scene, 6285, 223);
    this.add(platformMarkerPlatMini_9);

    // megaGemMarker_3
    const megaGemMarker_3 = new MegaGemMarker(scene, 6877, 246);
    this.add(megaGemMarker_3);

    // megaGemMarker_4
    const megaGemMarker_4 = new MegaGemMarker(scene, 7103, 246);
    this.add(megaGemMarker_4);

    // megaGemMarker_5
    const megaGemMarker_5 = new MegaGemMarker(scene, 6992, 244);
    this.add(megaGemMarker_5);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 1666, 93);
    this.add(gemMarker_6);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 1740, 93);
    this.add(gemMarker_7);

    // gemMarker_8
    const gemMarker_8 = new SmallGemMarker(scene, 2009, 207);
    this.add(gemMarker_8);

    // gemMarker_9
    const gemMarker_9 = new SmallGemMarker(scene, 2087, 208);
    this.add(gemMarker_9);

    // gemMarker_10
    const gemMarker_10 = new SmallGemMarker(scene, 2605, 163);
    this.add(gemMarker_10);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 2802, 132);
    this.add(gemMarker_11);

    // gemMarker_19
    const gemMarker_19 = new SmallGemMarker(scene, 3150, 107);
    this.add(gemMarker_19);

    // gemMarker_28
    const gemMarker_28 = new SmallGemMarker(scene, 3231, 107);
    this.add(gemMarker_28);

    // gemMarker_30
    const gemMarker_30 = new SmallGemMarker(scene, 3748, 213);
    this.add(gemMarker_30);

    // gemMarker_31
    const gemMarker_31 = new SmallGemMarker(scene, 3831, 211);
    this.add(gemMarker_31);

    // gemMarker_33
    const gemMarker_33 = new SmallGemMarker(scene, 4126, 146);
    this.add(gemMarker_33);

    // gemMarker_34
    const gemMarker_34 = new SmallGemMarker(scene, 4602, 104);
    this.add(gemMarker_34);

    // gemMarker_35
    const gemMarker_35 = new SmallGemMarker(scene, 4680, 104);
    this.add(gemMarker_35);

    // platformMarkerRock_1
    const platformMarkerRock_1 = new PlatformMarkerRock(scene, 2605, 286);
    this.add(platformMarkerRock_1);

    // platformMarkerStack_17
    const platformMarkerStack_17 = new PlatformMarkerStack2(scene, 4126, 284);
    this.add(platformMarkerStack_17);

    // smashableMarkerRocks_3
    const smashableMarkerRocks_3 = new SmashableMarkerRocks(scene, 5238, 103);
    this.add(smashableMarkerRocks_3);

    // platformMarkerPlat_4
    const platformMarkerPlat_4 = new PlatformMarkerPlat(scene, 5247, -87);
    this.add(platformMarkerPlat_4);

    // trapMarkerTorch_5
    const trapMarkerTorch_5 = new TrapMarkerTorch(scene, 5119, -177);
    this.add(trapMarkerTorch_5);

    // trapMarkerTorch_8
    const trapMarkerTorch_8 = new TrapMarkerTorch(scene, 5249, -171);
    this.add(trapMarkerTorch_8);

    // trapMarkerTorch_9
    const trapMarkerTorch_9 = new TrapMarkerTorch(scene, 5371, -174);
    this.add(trapMarkerTorch_9);

    // platformMarkerGroundLava_4
    const platformMarkerGroundLava_4 = new PlatformMarkerGroundLava(scene, 1105, 297);
    this.add(platformMarkerGroundLava_4);

    // smashableMarkerRocks_4
    const smashableMarkerRocks_4 = new SmashableMarkerRocks(scene, 1214, 94);
    this.add(smashableMarkerRocks_4);

    // platformMarkerPlat_5
    const platformMarkerPlat_5 = new PlatformMarkerPlat(scene, 1223, -93);
    this.add(platformMarkerPlat_5);

    // trapMarkerTorch_10
    const trapMarkerTorch_10 = new TrapMarkerTorch(scene, 1095, -183);
    this.add(trapMarkerTorch_10);

    // trapMarkerTorch_11
    const trapMarkerTorch_11 = new TrapMarkerTorch(scene, 1225, -177);
    this.add(trapMarkerTorch_11);

    // trapMarkerTorch_12
    const trapMarkerTorch_12 = new TrapMarkerTorch(scene, 1347, -180);
    this.add(trapMarkerTorch_12);

    // platformMarkerRock_2
    const platformMarkerRock_2 = new PlatformMarkerRock(scene, 5911, 302);
    this.add(platformMarkerRock_2);

    // platformMarkerRock_3
    const platformMarkerRock_3 = new PlatformMarkerRock(scene, 6577, 302);
    this.add(platformMarkerRock_3);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, 344, 257);
    this.add(checkpointMarker);

    // checkpointMarker_1
    const checkpointMarker_1 = new CheckpointMarker(scene, 6865.582579121279, 250.77532652577418);
    this.add(checkpointMarker_1);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;

    // smashableMarkerRocks_3 (components)
    const smashableMarkerRocks_3SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerRocks_3);
    smashableMarkerRocks_3SimpleBreakableBlocker.allowedCharacter = "panda";

    // smashableMarkerRocks_4 (components)
    const smashableMarkerRocks_4SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerRocks_4);
    smashableMarkerRocks_4SimpleBreakableBlocker.allowedCharacter = "ice";

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
